import { createGetStaticPropsFromStoryblok } from './create-get-static-props';
import { interceptStaticPropsResult } from './intercept-static-props-result';

export const getStaticPropsFromStoryblok = createGetStaticPropsFromStoryblok({
  resultInterceptor: interceptStaticPropsResult,
});
